import { useState, useEffect } from 'react';

/**
 * Hook personnalisé pour détecter si la page est visible ou cachée
 * Utile pour pauser des opérations (comme le polling) quand l'onglet n'est pas actif
 *
 * @returns {boolean} isVisible - true si la page est visible, false sinon
 */
const usePageVisibility = () => {
    const [isVisible, setIsVisible] = useState(!document.hidden);

    useEffect(() => {
        const handleVisibilityChange = () => {
            setIsVisible(!document.hidden);
        };

        // Écouter l'événement de changement de visibilité
        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Cleanup : retirer l'event listener au unmount
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    return isVisible;
};

export default usePageVisibility;
